export default __webpack_public_path__ + "static/media/event-active.70b7e0d2.svg";